import type {Meta, StoryObj} from "@storybook/web-components";
import type {NotificationBell} from "../../src/components/notification-bell/notification-bell";

import {html} from "lit";

const meta: Meta<NotificationBell> = {
	title: "Notification/Notification Bell",
	component: "uxn-notification-bell",

	decorators: [
		(story) =>
			html` <fragment>
				<ux-u-silent-auth
					issuer="https://identity-s.trumpf.com"
					client-id="zyffE9ozijzUpQqdaOyteGMJfhMa"
					client-name="notificationmanagement"
					scope="openid"
					debug="true"
				></ux-u-silent-auth>
				${story()}
			</fragment>`,
	],

	render: ({env, debug}) => html` <uxn-notification-bell env="${env}" debug="${debug}"></uxn-notification-bell> `,

	argTypes: {
		// counter: {control: "range", min: 0, max: 100, step: 1},
		env: {control: "select", options: ["prod", "qa", "dev"]}, //! are those really the available variants?
		debug: {control: "boolean"},
	},
};

export default meta;
type Story = StoryObj<NotificationBell>;

export const Default: Story = {
	args: {
		// counter: 42,
		env: "prod",
		debug: true,
	},
};

export const NoNotifications: Story = {
	parameters: {
		controls: {include: []},
	},
	args: {
		...Default.args,
		// counter: 0,
	},
};

export const MaxNotifications: Story = {
	parameters: {
		controls: {include: []},
	},
	args: {
		...Default.args,
		// counter: 100,
	},
};
